import { render, staticRenderFns } from "./stage-list.vue?vue&type=template&id=0fd391ff&scoped=true&"
import script from "./stage-list.vue?vue&type=script&lang=js&"
export * from "./stage-list.vue?vue&type=script&lang=js&"
import style0 from "./stage-list.vue?vue&type=style&index=0&id=0fd391ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd391ff",
  null
  
)

export default component.exports